<div class="content-1920">
  <div class="content-padding margin-top-small">
    <app-user-management></app-user-management>
  </div>
</div>
